export const GET_PRODUCT_DETAIL_LIST_REQUEST =
  "get_product_detail_list_request";
export const GET_PRODUCT_DETAIL_LIST_RESPONSE =
  "get_product_detail_list_response";

export const GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_REQUEST =
  "get_product_detail_list_by_product_category_id_request";
export const GET_PRODUCT_DETAIL_LIST_BY_PRODUCT_CATEGORY_ID_RESPONSE =
  "get_product_detail_list_by_product_category_id_response";

export const ADD_PRODUCT_DETAIL_REQUEST = "add_product_detail_request";
export const ADD_PRODUCT_DETAIL_RESPONSE = "add_product_detail_response";

export const UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST =
  "update_product_detail_by_product_detail_id_request";
export const UPDATE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE =
  "update_product_detail_by_product_detail_id_response";

export const DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_REQUEST =
  "delete_product_detail_by_product_detail_id_request";
export const DELETE_PRODUCT_DETAIL_BY_PRODUCT_DETAIL_ID_RESPONSE =
  "delete_product_detail_by_product_detail_id_response";

export const UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_REQUEST =
  "update_product_detail_status_by_product_detail_id_request";
export const UPDATE_PRODUCT_DETAIL_STATUS_BY_PRODUCT_DETAIL_ID_RESPONSE =
  "update_product_detail_status_by_product_detail_id_response";

export const GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST =
  "get_product_images_by_product_details_id_request";
export const GET_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE =
  "get_product_images_by_product_details_id_response";

export const UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST =
  "update_product_images_by_product_detail_id_request";
export const UPDATE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE =
  "update_product_images_by_product_detail_id_response";

export const DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_REQUEST =
  "delete_product_images_by_product_detail_id_request";
export const DELETE_PRODUCT_IMAGES_BY_PRODUCT_DETAIL_ID_RESPONSE =
  "delete_product_images_by_product_detail_id_response";

export const SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_REQUEST =
  "set_default_image_for_product_detail_request";
export const SET_DEFAULT_IMAGE_FOR_PRODUCT_DETAIL_RESPONSE =
  "set_default_image_for_product_detail_response";

export const SET_PRODUCT_CATEGORY_ID = "set_product_category_id";
